export default __webpack_public_path__ + "static/media/239.525e2153.gif";